import { render, staticRenderFns } from "./TalkSymposium.vue?vue&type=template&id=8ff0a5ba&scoped=true"
import script from "./TalkSymposium.vue?vue&type=script&lang=js"
export * from "./TalkSymposium.vue?vue&type=script&lang=js"
import style0 from "./TalkSymposium.vue?vue&type=style&index=0&id=8ff0a5ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ff0a5ba",
  null
  
)

export default component.exports